// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IReportHeader
 */
export interface IReportHeader {
    /**
     * 
     * @type {number}
     * @memberof IReportHeader
     */
    position?: number;
    /**
     * 
     * @type {string}
     * @memberof IReportHeader
     */
    field_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IReportHeader
     */
    column_label?: string;
    /**
     * 
     * @type {string}
     * @memberof IReportHeader
     */
    column_type?: string;
}

/**
 * Check if a given object implements the IReportHeader interface.
 */
export function instanceOfIReportHeader(value: object): value is IReportHeader {
    return true;
}

export function IReportHeaderFromJSON(json: any): IReportHeader {
    return IReportHeaderFromJSONTyped(json, false);
}

export function IReportHeaderFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportHeader {
    if (json == null) {
        return json;
    }
    return {
        
        'position': json['position'] == null ? undefined : json['position'],
        'field_name': json['field_name'] == null ? undefined : json['field_name'],
        'column_label': json['column_label'] == null ? undefined : json['column_label'],
        'column_type': json['column_type'] == null ? undefined : json['column_type'],
    };
}

export function IReportHeaderToJSON(json: any): IReportHeader {
    return IReportHeaderToJSONTyped(json, false);
}

export function IReportHeaderToJSONTyped(value?: IReportHeader | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'position': value['position'],
        'field_name': value['field_name'],
        'column_label': value['column_label'],
        'column_type': value['column_type'],
    };
}

